import {docsTags, docsOwnTags} from '@/constants/documentTags'
import setStyles from '@/constants/Forms/setStyles'

const inputs = [
  {
    id: 'name',
    label: 'Document name',
    type: 'string',
    model: 'label',
    require: true
  },
  {
    id: 'own',
    label: 'Ownership type',
    placeholder: 'Set ownership type',
    type: 'select',
    selectType: 'tag',
    list: docsOwnTags,
    labelList: 'name',
    clearable: true,
    searchable: false,
    model: 'own',
    require: true,
    selectPopup: true
  },
  {
    id: 'tag',
    label: 'Type of document',
    placeholder: 'Set type of document',
    type: 'select',
    selectType: 'tag',
    list: docsTags,
    labelList: 'name',
    clearable: true,
    searchable: false,
    model: 'tag',
    require: true
  },
  {
    id: 'comment',
    label: 'Comment',
    type: 'textarea',
    styleProps: 'textarea',
    placeholder: 'Enter text...',
    model: 'comment'
  }
]

const styles = {
  default: {
    gridGap: '8px'
  },
  textarea: {
    gridColumn: '1/4',
    gridGap: '8px'
  }
}

const contactsDocsInputs = setStyles(inputs, styles)

export default contactsDocsInputs



// WEBPACK FOOTER //
// ./src/constants/Forms/contactDocsForm.js